import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body2,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { constants } from '@myphx-engineering/phx-design-system/framework';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../../graphql/generated/graphql';
import type { PricingInfo } from '../../../util/config/get-pricing';

import MedicationPricing from './MedicationPricing';

type PreviewKwikpenDetailsProps = {
    pricingInfo: PricingInfo;
    medication?:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment;
};

export const PreviewKwikpenDetails = ({
    pricingInfo,
    medication,
}: PreviewKwikpenDetailsProps) => {
    const { t } = useTranslation();
    const [opened, { toggle }] = useDisclosure(false);

    return (
        <>
            <MedicationPricing
                pricingInfo={pricingInfo}
                medication={medication}
                data-testid="pharmacy-preview-pricing-card"
            />

            <Stack gap="xs">
                <Body2>
                    {t('previewDetails.kwikpenDescription', {
                        reg: constants.unicode.REGISTERED,
                    })}
                </Body2>
                <Body2>
                    <Anchor onClick={toggle} textDecoration="underline">
                        {t('previewDetails.termsAndConditions.kwikpen.link')}
                    </Anchor>
                </Body2>
            </Stack>

            <Modal
                opened={opened}
                onClose={toggle}
                title={t('previewDetails.termsAndConditions.kwikpen.title', {
                    reg: constants.unicode.REGISTERED,
                })}
            >
                <Stack data-testid="pharmacy-preview-terms-and-conditions">
                    <Body2>
                        {t('previewDetails.termsAndConditions.kwikpen.body1', {
                            reg: constants.unicode.REGISTERED,
                        })}
                    </Body2>
                    <Body2>
                        {t('previewDetails.termsAndConditions.kwikpen.body2', {
                            reg: constants.unicode.REGISTERED,
                        })}
                    </Body2>
                    <Body2>
                        <Trans
                            i18nKey="previewDetails.termsAndConditions.kwikpen.body3"
                            components={{
                                1: <strong />,
                            }}
                            values={{
                                reg: constants.unicode.REGISTERED,
                            }}
                        />
                    </Body2>
                </Stack>
            </Modal>
        </>
    );
};
